import { React, useEffect, useState } from "react";
import { IntroductionHeader } from "../../dashboard/Dashboard";
import InformationHeader from "../Partials/InformationHeader";
import { AddproductWrapper } from "../../Products/ProductsPage.styled";
import { ReportTemplate } from "../Accounts.styled";
import { FormGroup } from "../../customer/customersPage.styled";
import { InputField, FileGroup } from "../../../components/Form/FormComponents";
import { useParams } from "react-router-dom";
// import { toast } from "react-toastify";
import { fetchAFobject } from "../../apprenticeship/utils";
import { Backdrop, CircularProgress } from "@mui/material";
import { getFormattedDate } from "../../../utils/DateUtils";

function AFreport() {
	let { id } = useParams();
	const [loading, setLoading] = useState(false);
	const [formData, setFormData] = useState([]);

	useEffect(() => {
		getAFData();
	}, []);

	const getAFData = async () => {
		const data = await fetchAFobject(id);
		console.log(data)
		if (data?.result?.report && !data?.error) {
			setLoading(false);
			setFormData(data.result.report);
			// console.log(data.result.report);
		} else {
			setLoading(false);
			setFormData([]);
			// toast.error(data?.error || "Error fetching reports");
		}
	};

	return (
		<>
			<IntroductionHeader nav={true} />
			<InformationHeader getAFData={getAFData} getData type={"reportPage"} />
			<AddproductWrapper>
				<ReportTemplate>
					{formData?.length <= 0 ? (
						<p>No report found</p>
					) : (
						formData?.map((data, index) => {
							return (
								<div key={index} className='flex gap-8'>
									<FormGroup>
										<label>DATE / TIME</label>
										<InputField
											name='createdAt'
											value={getFormattedDate(data?.date?.iso) || "--"}
										/>
									</FormGroup>

									<FormGroup className='mt-6'>
										<label>UPLOADED FILE</label>
										<FileGroup value={data?.url} />
									</FormGroup>
								</div>
							);
						})
					)}
				</ReportTemplate>
				{loading && (
					<Backdrop
						sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
						open={loading}
					>
						<CircularProgress color='inherit' />
					</Backdrop>
				)}
			</AddproductWrapper>
		</>
	);
}

export default AFreport;
